export var dataProperties={businessHours:'businessHours'};// Indicate the Business Hour Style
export var Mode={INLINE:'inline',VERTICAL:'vertical'};